/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_footer_services_promo_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kódy slev`
};

const da_footer_services_promo_code = /** @type {(inputs: {}) => string} */ () => {
	return `Rabatkoder`
};

const de_footer_services_promo_code = /** @type {(inputs: {}) => string} */ () => {
	return `Rabattcodes`
};

const en_footer_services_promo_code = /** @type {(inputs: {}) => string} */ () => {
	return `Promo codes`
};

const es_footer_services_promo_code = /** @type {(inputs: {}) => string} */ () => {
	return `Códigos promocionales`
};

const fr_footer_services_promo_code = /** @type {(inputs: {}) => string} */ () => {
	return `Codes promo`
};

const hu_footer_services_promo_code = /** @type {(inputs: {}) => string} */ () => {
	return `Promóciós kódok`
};

const it_footer_services_promo_code = /** @type {(inputs: {}) => string} */ () => {
	return `Codici sconto`
};

const nl_footer_services_promo_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kortingscodes`
};

const pl_footer_services_promo_code = /** @type {(inputs: {}) => string} */ () => {
	return `Kody rabatowe`
};

const pt_footer_services_promo_code = /** @type {(inputs: {}) => string} */ () => {
	return `Códigos promocionais`
};

const sv_footer_services_promo_code = /** @type {(inputs: {}) => string} */ () => {
	return `Rabattkoder`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const footer_services_promo_code = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_services_promo_code(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer_services_promo_code", locale)
	if (locale === "cs") return cs_footer_services_promo_code(inputs)
	if (locale === "da") return da_footer_services_promo_code(inputs)
	if (locale === "de") return de_footer_services_promo_code(inputs)
	if (locale === "en") return en_footer_services_promo_code(inputs)
	if (locale === "es") return es_footer_services_promo_code(inputs)
	if (locale === "fr") return fr_footer_services_promo_code(inputs)
	if (locale === "hu") return hu_footer_services_promo_code(inputs)
	if (locale === "it") return it_footer_services_promo_code(inputs)
	if (locale === "nl") return nl_footer_services_promo_code(inputs)
	if (locale === "pl") return pl_footer_services_promo_code(inputs)
	if (locale === "pt") return pt_footer_services_promo_code(inputs)
	return sv_footer_services_promo_code(inputs)
};
export { footer_services_promo_code as "footer.services.promo_code" }